import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateDeleteLookupOptionMutation, MutateDeleteLookupOptionMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'

const document = graphql(/* graphql */`
  mutation mutateDeleteLookupOption($key: String!, $id: MongoID!) {
    lookups {
      delete(key: $key, _id: $id) {
        deletedCount
      }
    }
  }
`)

export type UseMutateDeleteLookupOptionReturn = UseMutationResult<
MutateDeleteLookupOptionMutation,
unknown,
MutateDeleteLookupOptionMutationVariables
>

const useMutateDeleteLookupOption = (): UseMutateDeleteLookupOptionReturn => {
  return useGraphMutation(document)
}

export { useMutateDeleteLookupOption, document as mutateDeleteLookupOptionDocument }
